export default "__VITE_ASSET__83c47a83__"